import React from 'react'

const SvgHeadset = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11 4a5 5 0 00-5 5 2 2 0 012 2v4a2 2 0 01-4 0V9a7 7 0 017-7h2a7 7 0 017 7v6.5a1.5 1.5 0 01-1.5 1.5v3a1 1 0 01-1 1H15a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a1 1 0 011-1h3a1 1 0 011 1h2.5v-3a1.5 1.5 0 01-1.5-1.5V11a2 2 0 012-2 5 5 0 00-5-5h-2z'
    />
  </svg>
)

export default SvgHeadset
